export enum Resolutions {
  '1080p' = '1080p',
  '720p' = '720p',
}
